var render, staticRenderFns
import script from "./AmgIcon.vue?vue&type=script&lang=js"
export * from "./AmgIcon.vue?vue&type=script&lang=js"
import style0 from "./AmgIcon.vue?vue&type=style&index=0&id=c631a362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports